import uniq from 'lodash/uniq'
import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

interface INineGridBox {
  [key: string]: any
}
class NineGridBox extends Model<INineGridBox> {
  static urlRoot() {
    return '/competencies/users_competencies'
  }

  constructor(data: INineGridBox) {
    super(data)

    makeObservable(this, {
      id: computed,
      competencyId: computed,
      competencyName: computed,
      competencyDescription: computed,
      children: computed,
      parentId: computed,
      accessId: computed,
      nineGridValue: computed,
      value: computed,
    })
  }

  get id(): number {
    return Number(this.attributes.id)
  }

  get competencyId(): number {
    return Number(this.attributes.competency_id)
  }

  get accessId(): number {
    return Number(this.attributes.access_id)
  }

  get nineGridValue(): number {
    return Number(this.attributes.nine_grid_value)
  }

  get value(): number {
    return Number(this.attributes.value)
  }

  get competencyName(): string {
    return this.attributes.competency_name
  }

  get competencyDescription(): string {
    return this.attributes.competency_description
  }

  get parentId(): number | null {
    return this.attributes.competency_parent_id
      ? Number(this.attributes.competency_parent_id)
      : null
  }

  get children(): number[] {
    const childrenNinegridboxes =
      this.collection?.filter({
        competency_parent_id: this.attributes.competency_id,
      }) ?? []

    const childrenNinegridboxesIds = childrenNinegridboxes.map(
      (child) => child.attributes.competency_id
    )
    const childrenCompetencies = uniq(childrenNinegridboxesIds)

    return childrenCompetencies
  }
}

export default NineGridBox
